
import { MutationTypes as AuthMutationTypes } from "@/store/modules/auth";
import { MutationTypes as UserMutationTypes } from "@/store/modules/user";
import axios from "axios";
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      password: "",
      wrongPassword: false,
      errorAPI: false,
    };
  },
  computed: {
    me() {
      return this.$store.getters[`user/getMe`];
    },
  },
  methods: {
    closeModal() {
      this.password = "";
      this.wrongPassword = false;
      this.$emit("closeDeleteAccountModal");
    },
    async deleteAccount() {
      const checkPasswordResponse = await axios.post("login", {
        email: this.me.user.email,
        password: this.password,
      });

      if (checkPasswordResponse.status !== 200)
        return (this.wrongPassword = true);

      const deleteAccountResponse = await axios.delete(
        `/athletes/${this.me.user.id}`
      );
      if (deleteAccountResponse.status !== 200) return (this.errorAPI = true);

      this.$store.commit(`user/${UserMutationTypes.SET_USER_ME}`, {});
      this.$store.commit(`auth/${AuthMutationTypes.LOGOUT}`);
      this.$router.push({ name: "Login" });
    },
  },
});
